module.exports = __webpack_public_path__ + "img/about_3.747f8519.svg";